import { render, staticRenderFns } from "./DescTile.vue?vue&type=template&id=76048472&"
import script from "./DescTile.vue?vue&type=script&lang=js&"
export * from "./DescTile.vue?vue&type=script&lang=js&"
import style0 from "./DescTile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DescTile.vue"
export default component.exports